function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.85913 11.0901C2.5522 8.96551 3.74932 7.09464 5.29297 5.54086C7.90774 2.90896 11.4991 1.29176 15.5 1.29176C19.5009 1.29176 23.0923 2.90896 25.707 5.54086C27.2507 7.09464 28.4163 8.96551 29.1409 11.0901",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.329 15.8307C25.329 10.3754 20.9354 5.95309 15.5157 5.95309C10.096 5.95309 5.70251 10.3754 5.70251 15.8307C5.70251 21.2859 10.096 25.7082 15.5157 25.7082C20.9354 25.7082 25.329 21.2859 25.329 15.8307Z",
  fill: "white",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3047 22.6641L25.0454 25.4228",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.69531 22.6641L5.98604 25.4228",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5693 8.83868L5.29297 5.54086",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4622 8.83868L25.707 5.54086",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 5.95309V1.29176",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var SvgBarChair = function SvgBarChair(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarChair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/barChair.96422130.svg";
export { ForwardRef as ReactComponent };